exports = module.exports = require("../../../../../tools/web-builder/node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".login-route-3d9 .back-to-login{cursor:pointer;color:#11a1fd}", "",{"version":3,"sources":["login-route.scss"],"names":[],"mappings":"AACE,gCACE,cAAA,CACA,aAAA","file":"login-route.scss","sourcesContent":[".login-route-3d9 {\r\n  .back-to-login {\r\n    cursor: pointer;\r\n    color: #11A1FD;\r\n  }\r\n}\r\n"]}]);

